export const permitsAndLicensesTemplate = [
	{
		id: 'e92d5fe2-df03-430f-9a58-5017157e8e3a',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Purpose',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '7133cc75-3d40-4328-a700-e6fc54840ef7',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Maintain an organized record of all active permits and licenses required for building operations, compliance, and safety for this location.',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '12cfd0dc-24a0-4fd0-94c4-c95dbca9be36',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '1. General Information',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '8dd7957b-2014-479e-b60d-011b8a093725',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Location / Property Name:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '96d6b7d2-dd3f-45ca-8d6b-e7370108935b',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Address:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '683ac635-a8ee-459b-80c6-f6520a87af9b',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Prepared By:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'fc4b6eaa-64b6-4479-b3c8-1a3ba82ee3e9',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Last Updated:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '31aa8442-a342-476c-bec4-e7ba972e40c7',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'b8341d7f-a103-412e-8c1e-bf8d3a001bb5',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '2. Permits and Licenses',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '82aadd46-0c10-464b-8b66-be7da2aa352b',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'For each entry, include:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'ddcfece6-017c-451e-8d0d-2615b7606642',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Permit / License Type: (e.g., Fire Safety, Elevator, HVAC, Food Service, Liquor, Waste Disposal, Construction, Occupancy, etc.)',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5fb356a2-caef-4662-a404-1c578bd72e36',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Permit / License Number:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'eb9797f2-18c7-407e-91cf-1fe0ae90f611',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Issuing Authority / Agency:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5a14b6e1-c664-4684-afef-b544b9f9b65c',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Issue Date:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'a0f765ab-8c77-4c1d-871b-cd289a2829e1',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Expiration Date:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'b1e9bcea-b2a6-4e63-ae97-3e971281a86a',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Renewal Cycle: (Annual, Bi-Annual, Every 5 Years, etc.)',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'b535bbfd-221a-4ada-8e87-e3b16f3ce7f5',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Renewal Status: (Pending / Submitted / Approved)',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'c42e4dc5-37aa-44cc-a1b6-2dac2523c373',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Responsible Party / Contact Person:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5aece26a-a045-4398-b61f-099ff8390d43',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Inspection / Service Provider (if applicable): Name + Contact Info',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '99dbed4d-2695-4feb-8988-3bb66621dca2',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Last Audit Date / Next Scheduled Audit:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'd6a24db6-d545-40d3-ba69-28cd2edd0bda',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Location(s) Covered:',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'b6eadf68-c091-48b4-a0a4-e881d2bb1611',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Associated Documents: (Upload scans, PDFs, certificates, inspection reports)',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'fb44eaed-9dca-44bb-8a7a-31b09354e0f7',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Notes on Special Requirements: (e.g., inspections required before renewal)',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '08384d34-5a36-41fd-9d17-bcb31c921afa',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'ecfaecbd-3ce0-4ae5-b2ca-212c43cbaed4',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '3. Notes / Additional Information',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '555419a0-56d3-47fc-b36e-24b789822b1e',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'e233fd0a-ff72-492c-8f3d-5a9df7d2af3c',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Open text field for special conditions, exceptions, or reminders.',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '554c802c-6627-42a9-aab9-e2c789367410',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [],
		children: [],
	},
];
